/**
 * Tracking Constants
 * Centralized constants for tracking interactions, actions, and events
 */

export const TRACKING_INTERACTION = {
  ACCESS_TEMPLATES: 'access-templates',
  CLICK_ABSENCE_MANAGEMENT: 'click-absenceManagement',
  CLICK_ADMINISTRATION: 'click-administration',
  CLICK_AI_CHAT: 'click-ai-chat',
  CLICK_AI_ASSISTANT: 'click-ai-assistant',
  CLICK_GRADES_AND_CERTIFICATIONS: 'click-grades-and-certifications',
  CLICK_AI_WRITING_TOOL: 'click-ai-writing-tool',
  CLICK_AI_NEWS_TEXT_FEEDBACK: 'click-ai-news-text-feedback',
  CLICK_AI_NEWS_TEXT_FEEDBACK_FINISHED: 'click-ai-news-text-feedback-finished',
  CLICK_AI_NEWS_GENERATE: 'click-ai-news-generate',
  CLICK_AI_NEWS_GENERATE_ACCEPTED: 'click-ai-news-generate-accepted',
  CLICK_AI_NEWS_GENERATION_HINT_OPEN: 'click-ai-news-generation-hint-open',
  CLICK_AI_NEWS_GENERATION_HINT_CLOSE: 'click-ai-news-generation-hint-close',
  CLICK_APP_SWITCHER: 'click-app-switcher',
  CLICK_AUTHENTICATOR: 'click-authenticator',
  CLICK_CALENDAR: 'click-calendar',
  CLICK_CHANGE_HISTORY: 'click-change-history',
  CLICK_CLASS_REGISTER: 'click-classRegister',
  CLICK_CLASS: 'click-class',
  CLICK_CLOUD: 'click-cloud',
  CLICK_CONTACT_CREATOR: 'click-contact-creator',
  CLICK_CUSTOM_LINK: 'click-custom-link',
  CLICK_DAY_CARE: 'click-daycare',
  CLICK_DAYCARE: 'click-daycare',
  CLICK_DIGITAL_GRADE_BOOK: 'click-digital-gradebook',
  CLICK_ENTITY: 'click-entity',
  CLICK_EVENT: 'click-event',
  CLICK_FUJITSU: 'click-fujitsu',
  CLICK_INFO: 'click-info',
  CLICK_INVENTORY: 'click-inventory',
  CLICK_JUMP_TO_TODAY: 'click-jump-to-today',
  CLICK_LEARNING_REPORTS: 'click-learning-reports',
  CLICK_LESSON_INFO: 'click-lesson-info',
  CLICK_LESSON_PLANNING: 'click-lesson-planning',
  CLICK_MAIN_MENU: 'click-main-menu',
  CLICK_MEDIA_LIBRARY: 'click-media-library',
  CLICK_MEETING_PROTOCOLS: 'click-meeting-protocols',
  CLICK_MORE_CLASSBOOK: 'click-more-classbook',
  CLICK_NEWS: 'click-news',
  CLICK_NOTIFICATION: 'click-notification',
  CLICK_PARENT_MEETINGS: 'click-parent-meetings',
  CLICK_AI_SCHEDULE_PLANNER: 'click-ai-schedule-planner',
  CLICK_ROOM_BOOKING: 'click-room-booking',
  CLICK_SOCIAL_MANAGEMENT: 'click-social-management',
  CLICK_SDUI_ACADEMY: 'click-sduiAcademy',
  CLICK_SDUI_PLANNER: 'click-sduiPlanner',
  CLICK_SDUI_PLUS: 'click-sduiPlus',
  CLICK_TUTORIAL: 'click-tutorial',
  HIDE_TUTORIAL: 'hide-tutorial',
  HELP_START: 'click-get-help',
  OPEN: 'open',
  RELEASE_NOTES: 'click-update-info',
  REMOVE: 'remove',
  SELECT_VIEW_BY_LIST: 'select-view-by-list',
  SELECT_VIEW_BY_DAY: 'select-view-by-day',
  SELECT_VIEW_BY_WEEK: 'select-view-by-week',
  SELECT_VIEW_BY_MONTH: 'select-view-by-month',
  SETTINGS_COPYRIGHT: 'click-data-protection-info',
  SETTINGS_VIDEOS: 'click-explain-video',
  CLICK_TRANSLATE: 'click-translate',
  VIEW_NEWS_DETAILS: 'view-news-details',
  VIEW_READ_CONFIRMATIONS: 'view-read-confirmations',
  VIEW_READ_CONFIRMATIONS_BY_FAMILY: 'view-read-confirmations-by-family',
  VIEW_READ_CONFIRMATIONS_ALL: 'view-read-confirmations-all',
}

export const TRACKING_ACTION = {
  ACTIVATE: 'activate',
  ADD: 'add',
  CREATE_TEACHER_PARENT_CHANNEL: 'create-teacher-parent-channel',
  ADD_MEMBER: 'add-member',
  ADD_TEACHERS: 'add-teacher',
  ADD_GRADES: 'add-class',
  ADD_BOOKABLES: 'add-room',
  ADD_SUBJECTS: 'add-subject',
  ADD_TIMES: 'add-time-block',
  ADD_COURSES: 'add-course',
  ADD_HOLIDAYS: 'add-holiday',
  ARCHIVE: 'archive',
  CHANGE_EMAIL: 'change-email',
  CHANGE_PASSWORD: 'change-password',
  CHANGE_USERNAME: 'change-username',
  CHAT_REQUEST: 'chat-request',
  CLEAR_CHAT_HISTORY: 'clear-chat-history',
  CLEAR_HISTORY: 'clear-history',
  CLOSE: 'close',
  CLOSE_CONVERSATION: 'close-conversation',
  COPY: 'copy',
  CONFIRM_ALL: 'confirm-presence-all',
  CREATE: 'create',
  CREATE_CLOUD_FILE: 'create-file',
  CREATE_FOLDER: 'create-folder',
  CREATE_TEMPLATE: 'create-template',
  DEACTIVATE: 'deactivate',
  DELETE: 'delete',
  DELETE_ACCOUNT: 'delete-account',
  EDIT: 'edit',
  EXPORT: 'export',
  FORWARD: 'forward',
  HISTORY: 'history',
  HIDE_UNREAD: 'hide-unread',
  SHOW_UNREAD: 'show-unread',
  LOAD_TEMPLATE: 'load-template',
  LOGIN: 'login',
  LOGOUT: 'logout',
  LOGOUT_ALL_DEVICES: 'sign-out-everywhere',
  MAKE_ADMIN: 'make-admin',
  OPEN_CONVERSATION: 'open-conversation',
  PIN: 'pin',
  PREPARE_EXPORT: 'prepare-export',
  RECEIVE: 'receive',
  REGISTRATION: 'registration',
  REMOVE: 'remove',
  REMOVE_ADMIN: 'remove-admin',
  REMOVE_MEMBER: 'remove-member',
  REMOVE_TEACHERS: 'remove-teacher',
  REMOVE_GRADES: 'remove-class',
  REMOVE_BOOKABLES: 'remove-room',
  REMOVE_SUBJECTS: 'remove-subject',
  REMOVE_TIMES: 'remove-time-block',
  REMOVE_COURSES: 'remove-course',
  REMOVE_HOLIDAYS: 'remove-holiday',
  REPLY: 'reply',
  SEND: 'send',
  SUBMIT: 'submit',
  SWITCH_ACCOUNTS: 'switch-accounts',
  TOGGLE: 'toggle',
  TOKEN_CHANGE: 'token-change',
  MUTE: 'mute',
  UNMUTE: 'unmute',
  MARK_ABSENT: 'mark-absent',
  MUTE_NOTIFICATIONS: 'mute-notifications',
  UNMUTE_NOTIFICATIONS: 'unmute-notifications',
  MARK_PRESENT: 'mark-present',
  MARK_READ: 'mark-read',
  MARK_UNREAD: 'mark-unread',
  TWO_STEP_VERIFICATION: 'activate-2FA',
  UNARCHIVE: 'unarchive',
  UNPIN: 'unpin',
  UPLOAD: 'upload',
  SEND_REMINDER: 'send-reminder',
}

export const EVENT_KEY = {
  APP: {
    INTERACTION: 'app-interaction'
  },
  ADMIN: {
    ACTION: 'admin-action',
    END: 'admin-endAction',
    START: 'admin-startAction'
  },
  APP_SWITCHER: {
    INTERACTION: 'appSwitcher-interaction'
  },
  AUTH: {
    ACTION: 'auth-action',
    START: 'auth-startAction'
  },
  CALENDAR: {
    INTERACTION: 'calendar-interaction',
    END: 'calendar-endAction',
    START: 'calendar-startAction'
  },
  CARD: {
    INTERACTION: 'card-interaction'
  },
  CHANNEL: {
    ACTION: 'channel-action',
    END: 'channel-endAction',
    INTERACTION: 'channel-interaction',
    START: 'channel-startAction'
  },
  CLASSBOOK: {
    ACTION: 'classbook-action',
    END: 'classbook-endAction',
    INTERACTION: 'classbook-interaction',
    START: 'classbook-startAction'
  },
  CLOUD: {
    END: 'cloud-endAction',
    START: 'cloud-startAction'
  },
  DISCOVERY: {
    INTERACTION: 'discovery-interaction'
  },
  FEATURE_USE: 'feature-use',
  NEWS: {
    ACTION: 'news-action',
    END: 'news-endAction',
    INTERACTION: 'news-interaction',
    START: 'news-startAction'
  },
  AI: {
    INTERACTION: 'ai-interaction',
  },
  PUSH: {
    ACTION: 'push-action'
  },
  NOTIFICATION_CENTER: {
    ACTION: 'notificationCenter-action',
    INTERACTION: 'notificationCenter-interaction'
  },
  MORE: {
    INTERACTION: 'more-interaction'
  },
  SURVEY: {
    ACTION: 'survey-action',
    END: 'survey-endAction',
    START: 'survey-startAction'
  },
  TIMETABLE: {
    END: 'timetable-endAction',
    INTERACTION: 'timetable-interaction',
    START: 'timetable-startAction'
  },
  TUTORIAL: {
    INTERACTION: 'tutorial-interaction'
  },
  USER_SETTINGS: {
    END: 'userSettings-endAction',
    START: 'userSettings-startAction'
  }
}
